<template>
  <label class="volume-row" :class="tone" data-no-ui-sfx>
    <span class="label">{{ label }}</span>
    <span class="pct">{{ pct }}%</span>
    <input
      type="range"
      min="0"
      max="100"
      step="5"
      :value="pct"
      :aria-valuetext="`${pct}%`"
      :aria-label="label"
      @input="onInput"
    >
  </label>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { Bgm } from '../game/audio/Bgm'
import { DuelSfx } from '../game/audio/DuelSfx'
import { useI18n } from '../i18n/t'

const props = withDefaults(
  defineProps<{ tone?: 'duel' | 'menu'; channel?: 'music' | 'sfx' }>(),
  { tone: 'duel', channel: 'music' },
)

const { t } = useI18n()
const isSfx = computed(() => props.channel === 'sfx')
const label = computed(() =>
  isSfx.value ? t('settings.sfx') : t('settings.music'),
)
const pct = ref(
  Math.round((isSfx.value ? DuelSfx.getVolume() : Bgm.getVolume()) * 100),
)

function onInput(event: Event): void {
  const el = event.target as HTMLInputElement
  const next = Number(el.value)
  pct.value = next
  const gain = next / 100
  if (isSfx.value) {
    DuelSfx.prime()
    DuelSfx.setVolume(gain)
    return
  }
  Bgm.unlock()
  Bgm.setVolume(gain)
}
</script>

<style scoped>
.volume-row {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 4px 8px;
  margin: 0 0 14px;
  font-size: 12px;
  font-weight: 500;
  color: #f8fafc;
}

.volume-row input {
  grid-column: 1 / -1;
  width: 100%;
  accent-color: var(--md-sys-color-primary, #c9a227);
}

.pct {
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
}

.menu {
  color: var(--md-sys-color-on-surface);
}

.menu .pct {
  color: var(--md-sys-color-on-surface-variant);
}
</style>
